import React, { Component } from "react";
import "../../../../SCSS/setup.scss";
import "../../../../SCSS/services.scss";
import Axios from "axios";
import KenTable from "../../../../global_components/KenTable/kentable";
import { withRouter } from "react-router-dom";
import KenPaginationUI from "../../../../global_components/KenPaginator";
// import Loader from "../../../../../utils/loader/loaders";
import ServiceData from "./shift.json";
import KenForm from "../../../../global_components/KenForm/zqform";
import RestoreOutlinedIcon from "@material-ui/icons/RestoreOutlined";
// import HistoryIcon from "../../../../../assets/icons/history-icon.svg";
import NoteOutlinedIcon from "@material-ui/icons/NoteOutlined";
import KeyboardBackspaceSharpIcon from "@material-ui/icons/KeyboardBackspaceSharp";
import moment from "moment";
// import ZqHistory from "../../../../../gigaLayout/change-history";
import { Drawer } from "rsuite";
import KenContainerNavbar from "../../../../global_components/KenContainerNav";
// import zq_api from "../../../../../utils/api-service";
import { Alert } from 'rsuite';
import Snackbar from '@material-ui/core/Snackbar';
class ShiftSchedule extends Component {
  constructor(props) {
    super(props);
    // this.zq_api = new zq_api();
    this.state = {
      env: JSON.parse(localStorage.getItem("env")),
      useremail: localStorage.getItem("email"),
      channel: localStorage.getItem("channel"),
      BranchId: localStorage.getItem("branchid"),
      authToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjoicHIuYWRtaW4uYWxsQHplbnFvcmUuY29tIiwiVXNlcklkIjoiNjEzMWY3MmM4NTEwMTM1NDIyOTBmMWVhIiwiaWF0IjoxNjMwNjY0ODQ4fQ.X0gWTq-23DBuhjM8Jm-5IEb7fEqsOlRiHU31-HvmNuI",
      orgId: "606ac70479dbb25447375fa8",
      orgName: localStorage.getItem("orgName"),
      userId: localStorage.getItem("userId"),
      tabview: true,
      preview: true,
      ServiceFormData: ServiceData,
      loader: false,
      page: 1,
      limit: 10,
      totalRecord: 0,
      totalPages: 1,
      username: localStorage.getItem("username"),
      entityInstanceId: "",
      idosId: "",
      history: false,
      showHistory: false,
      historyData: [],
      submitCheck: false,
      containerNav: {
        isBack: false,
        name: "List of Shift",
        isName: true,
        isSearch: false,
        isSort: false,
        isPrint: true,
        isDownload: false,
        isShare: false,
        isNew: true,
        newName: "New",
        isSubmit: false,
      },
      tabData: [],
      tableResponse: 'Fetching Details..',
      snackBar: false,
      shiftId: "",
      addShiftId: "",
      timeout: "",
      timeIn: "",
      previewId: undefined

    };
  }
  componentDidMount() {
    this.getShiftsData();
  }
  getShiftsData = () => {
    this.setState({ loader: true });
    var headers = {
      'Authorization': "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjoicHIuYWRtaW4uYWxsQHplbnFvcmUuY29tIiwiVXNlcklkIjoiNjEzMWY3MmM4NTEwMTM1NDIyOTBmMWVhIiwiaWF0IjoxNjMwNjY0ODQ4fQ.X0gWTq-23DBuhjM8Jm-5IEb7fEqsOlRiHU31-HvmNuI"
    }
    Axios.get(`https://api.zenqore.com/payroll/uat/hkbk/masters/shift?org=${this.state.orgId}&page=${this.state.page}&limit=${this.state.limit}`, { headers: headers })
      .then(res => {
        console.log(res.data.data)
        if (res.data.status == 'success') {
          let tabData = [];
          let data = res.data.data;
          if (data.length > 0) {
            data.map(item => {
              let inTimeHour = String(String(Number(item.in) / 60).split('.')[0]).length == 1 ? `0${String(Number(item.in) / 60).split('.')[0]}` : String(Number(item.in) / 60).split('.')[0]
              let inTimeMin = String(Number(item.in) - Number(inTimeHour) * 60).length == 1 ? `0${String(Number(item.in) - Number(inTimeHour) * 60)}` : String(Number(item.in) - Number(inTimeHour) * 60)
              let outTimeHour = String(String(Number(item.out) / 60).split('.')[0]).length == 1 ? `0${String(Number(item.out) / 60).split('.')[0]}` : String(Number(item.out) / 60).split('.')[0]
              let outTimeMin = String(Number(item.out) - Number(outTimeHour) * 60).length == 1 ? `0${String(Number(item.out) - Number(outTimeHour) * 60)}` : String(Number(item.out) - Number(outTimeHour) * 60)
              let createdBy = item.personInfo.length > 0 ? `${item.personInfo['0']['salutation'] == "-" ? "" : item.personInfo['0']['salutation'] + " "}${item.personInfo['0']['firstName'] + " "}${item.personInfo['0']['lastName'] == "-" ? "" : item.personInfo['0']['lastName'] + " "}` : '-'
              tabData.push({
                'ID': item.id,
                //"Department": item.departmentDetails['0']['name'],
                'Title': item.title != undefined ? item.title : "-",
                "In Time": `${inTimeHour}:${inTimeMin}`,
                "Out Time": `${outTimeHour}:${outTimeMin}`,
                'Total Hours': item.totalHours != undefined ? item.totalHours : "-",
                "Created By": createdBy,
                'Status': item.status,
                "Item": JSON.stringify(item)
              })
            })
            this.setState({
              loader: false,
              tabData: tabData,
              page: res.data.currentPage,
              limit: res.data.perPage,
              totalRecord: res.data.totalRecord,
              totalPages: res.data.totalPages
            });
          } if (data.length == 0) {
            this.setState({
              loader: false, tableResponse: 'No data '
            });
          }
        }
      }).catch(err => {
        this.setState({
          loader: false, tableResponse: 'No Data'
        });
      })
  }
  // componentWillMount() {
  //   // this.setState({ ServiceFormData: ServiceData }, () => {
  //   if (this.props.location.data != undefined) {
  //     // this.setState({ globalSearch: true }, () => {
  //     this.onPreviewServices(this.props.location.data);
  //     // })
  //   }
  //   // })
  // }

  CreateGoods = () => {
    this.setState({ tabview: false });
  };
  onSubmit = (data, item) => {
    console.log(this.state.ServiceFormData, 'data')
    let userData = this.state.ServiceFormData;
    let apiNewCall = true;
    userData.map(item => {
      if (item.requiredBoolean) {
        if (item['defaultValue'] === "" || item['defaultValue'] === undefined || item['error'] || item['defaultValue'] == null) {
          item["error"] = true;
          item["validation"] = true
          item['errorMsg'] = `Invalid ${item.label}`
          apiNewCall = false
        } else {
          item["error"] = false;
          item["validation"] = false;
        }
      }
    })
    this.setState({ ServiceFormData: userData }, () => {
      if (apiNewCall) {
        this.setState({ loader: true }, () => {
          let payloadInput = {}
          this.state.ServiceFormData.map(item => {
            if (item.type != "heading" && item.category != "button") {
              payloadInput[item.name] = item.defaultValue
            }
          })
          console.log("payloadInput", payloadInput)
          let payload = {
            "id": payloadInput.ID,
            "title": payloadInput.title,
            "description": payloadInput.description,
            "in": `${new Date(payloadInput.inTime).getHours()}:${new Date(payloadInput.inTime).getMinutes()}`,
            "out": `${new Date(payloadInput.outTime).getHours()}:${new Date(payloadInput.outTime).getMinutes()}`,
            "totalHours": payloadInput.totalhrs,
            //"department": payloadInput.department,
            "userId": this.state.userId
          }
          var headers = {
            'Authorization': this.state.authToken
          }
          if (this.state.previewId == undefined) {
            Axios.post(`https://api.zenqore.com/payroll/uat/hkbk/masters/shift`, payload, { headers: headers })
              .then(res => {
                this.setState({ snackBar: true, processMessage: res.data.message }, () => {
                  setTimeout(() => {
                    this.setState({ snackBar: false, preview: false, tabview: true, previewId: undefined }, () => {
                      this.getShiftsData();
                    })
                  }, 2000)
                })
              }).catch(err => {
                this.setState({
                  loader: false
                }, () => {
                  this.setState({ snackBar: true, processMessage: err }, () => {
                    setTimeout(() => {
                      this.setState({ snackBar: false }, () => {
                      })
                    }, 2000)
                  })
                });
              })
          } else {
            Axios.put(`https://api.zenqore.com/payroll/uat/hkbk/masters/shift?id=${this.state.previewId}`, payload, { headers: headers })
              .then(res => {
                this.setState({ snackBar: true, processMessage: res.data.message }, () => {
                  setTimeout(() => {
                    this.setState({ snackBar: false, preview: false, tabview: true, previewId: undefined }, () => {
                      this.getShiftsData();
                    })
                  }, 2000)
                })
              }).catch(err => {
                this.setState({
                  loader: false
                }, () => {
                  this.setState({ snackBar: true, processMessage: err }, () => {
                    setTimeout(() => {
                      this.setState({ snackBar: false }, () => {
                      })
                    }, 2000)
                  })
                });
              })
          }
        })
      }

    })
  };
  onPreviewServices = (item) => {
    let ServiceFormData = this.state.ServiceFormData;
    let details = item;
    let fullDetails = JSON.parse(item.Item)
    let shiftId = fullDetails.id
    console.log("fullDetails", fullDetails)
    console.log(details);
    this.setState({ loader: true, previewId: fullDetails._id }, () => {
      // var headers = {
      //   'Authorization': localStorage.getItem('auth_token')
      // }
      // Axios.get(`https://api.zenqore.com/payroll/uat/hkbk/masters/department?org=${this.state.orgId}`, { headers: headers })
      //   .then(resDept => {
      //     console.log(resDept.data.data)
      //     if (resDept.data.status == 'success') {
      //       let deptOptions = []
      //       resDept.data.data.map(item => {
      //         deptOptions.push({
      //           label: item.name,
      //           value: item.id
      //         })
      //       })
      let dateValue = new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate()
      console.log(dateValue)
      ServiceFormData.map((item) => {
        if (item.name == 'ID') {
          item["defaultValue"] = details['ID'];
          item["readOnly"] = true;
          item["error"] = false;
          item["required"] = item.requiredBoolean
          item["validation"] = false
        }
        // if (item.name == "department") {
        //   item.options = deptOptions
        //   item.defaultValue = fullDetails['department']
        //   item["error"] = false;
        //   item["required"] = item.requiredBoolean
        //   item["validation"] = false
        // }
        if (item.name == 'title') {
          item["defaultValue"] = fullDetails['title']
          item["error"] = false;
          item["required"] = item.requiredBoolean
          item["validation"] = false
        }
        if (item.name == 'description') {
          item["defaultValue"] = fullDetails['description']
          item["error"] = false;
          item["required"] = item.requiredBoolean
          item["validation"] = false
        }
        if (item.name == "inTime") {
          item.defaultValue = new Date(`${dateValue} ${details['In Time']}:00`)
          item["error"] = false;
          item["required"] = item.requiredBoolean
          item["validation"] = false
        }
        if (item.name == "outTime") {
          item.defaultValue = new Date(`${dateValue} ${details['Out Time']}:00`)
          item["error"] = false;
          item["required"] = item.requiredBoolean
          item["validation"] = false
        }
        if (item.name == "totalhrs") {
          item.defaultValue = fullDetails['totalHours']
          item["error"] = false;
          item["required"] = item.requiredBoolean
          item["validation"] = false
        }
      });

      this.setState({ ServiceFormData: ServiceData }, () => {
        this.setState({ tabview: false, preview: true, loader: false, shiftId });
      });
      // }
      // })
    })
  };
  onPaginationChange = (page, limit) => {
    this.setState({ page: page, limit: limit }, () => {
      this.getShiftsData();
    });
  };
  resetform = () => {
    let ServiceFormData = this.state.ServiceFormData;
    ServiceFormData.map((item) => {
      item["defaultValue"] = undefined;
      item["readOnly"] = false;
      item["error"] = false;
      item["required"] = item.requiredBoolean
      item["validation"] = false
    });
    this.setState({ previewId: undefined })
    this.setState(ServiceFormData);
  };
  onAddServices = () => {
    let ServiceFormData = this.state.ServiceFormData;
    this.setState({ loader: true }, () => {
      var headers = {
        'Authorization': this.state.authToken
      }
      Axios.get(`https://api.zenqore.com/payroll/uat/hkbk/payroll/generateNextId?type=SHIFT&collection=shifts`, { headers: headers })
        .then(res => {
          console.log(res.data.data)
          // Axios.get(`https://api.zenqore.com/payroll/uat/hkbk/masters/department?org=${this.state.orgId}`, { headers: headers })
          //   .then(resDept => {
          //     console.log(resDept.data.data)
          // if (resDept.data.status == 'success') {
          //   let deptOptions = []
          //   resDept.data.data.map(item => {
          //     deptOptions.push({
          //       label: item.name,
          //       value: item.id
          //     })
          //   })
          let addShiftId = res.data.data;
          ServiceFormData.map((item) => {
            if (item.name == 'ID') {
              item["defaultValue"] = res.data.data;
              item["readOnly"] = true;
              item["error"] = false;
              item["required"] = item.requiredBoolean
              item["validation"] = false
            }
            // if (item.name == "department") {
            //   item.options = deptOptions
            // }
          });

          this.setState({ ServiceFormData: ServiceData }, () => {
            this.setState({ tabview: false, preview: false, loader: false, addShiftId });
          });
          // }
          // })

        }).catch(err => {
          this.setState({
            loader: false
          });
        })
    });


  };
  handleBack = () => {
    if (this.props.location.status != "active") {
      this.resetform();
      this.setState({ tabview: true });
    } else {
      this.props.history.goBack();
    }
  };



  onInputChanges = (value, item, e, dataS) => {
    console.log("value", value)
    console.log("item", item)
    console.log("e", e)
    console.log("dataS", dataS)

    let ServiceFormData = this.state.ServiceFormData

    // ServiceFormData.map(item => {
    //   if (dataS != undefined) {
    //     if (dataS["name"] === item.name) {
    //       item["defaultValue"] = value;
    //       item["error"] = false;
    //       item["required"] = item.requiredBoolean
    //       item["validation"] = false
    //     }
    //   }
    //   else {
    //     item["defaultValue"] = value
    //     item["error"] = false;
    //     item["required"] = item.requiredBoolean
    //     item["validation"] = false
    //   }
    // })
    // this.setState({ ServiceFormData: [] }, () => {
    //   this.setState({ ServiceFormData })
    // })


    if (dataS != undefined) {
      if (dataS["name"] === "inTime") {
        dataS["defaultValue"] = value;

      }


      if (dataS["name"] === "outTime") {
        dataS["defaultValue"] = value;
        let inTime = ""
        this.state.ServiceFormData.map(item => {
          if (item.name == "inTime") {
            inTime = item.defaultValue
          }
        })
        let time1 = inTime
        let timeIn = Number(new Date(time1).getHours() * 60) + Number(new Date(time1).getMinutes())
        console.log("timeIn", timeIn)
        let time2 = value
        let timeout = Number(new Date(time2).getHours() * 60) + Number(new Date(time2).getMinutes())
        console.log("timeout", timeout)
        let total = timeout >= timeIn ? (timeout - timeIn) : ((1440 - Number(timeIn)) + timeout);
        console.log("total", total)
        let totalHours = 0;

        if (total % 60) {
          let th = String(total / 60).split(".")
          let hours = String(Number(th[0])).length == 1 ? `0${String(Number(th[0]))}` : String(Number(th[0]))
          let minutes = String(Number(total) - (Number(th[0]) * 60)).length == 1 ? `0${String(Number(total) - (Number(th[0]) * 60))}` : String(Number(total) - (Number(th[0]) * 60))
          totalHours = hours + ":" + minutes
        }
        else {
          let hours = String(total / 60).length == 1 ? `0${String(total / 60)}` : String(total / 60)
          totalHours = hours + ":00"

        }
        console.log("totalHours", totalHours)
        ServiceFormData.map(item => {
          if (item.name == "totalhrs") {
            item.defaultValue = totalHours
          }
        })
        this.setState({ ServiceFormData: [] }, () => {
          this.setState({ ServiceFormData })
        })
      }





    }
    else {
      item["defaultValue"] = value
    }

  };
  formBtnHandle = (item) => {
    return item.type === "clear" ? this.cleartabData() : this.canceltabData();
  };
  cleartabData = () => {
    let issueDetailData = [];
    let formData = this.state.ServiceFormData;
    this.setState({ ServiceFormData: [] }, () => {
      formData.map((item) => {
        item["defaultValue"] = undefined;
        item["readOnly"] = false;
        if (item.required) {
          item["validation"] = false;
        }
      });
      issueDetailData = formData;
      console.log(issueDetailData, "issueDetailData");
      this.setState({
        ServiceFormData: issueDetailData,
      });
    });
  };
  canceltabData = () => {
    this.resetform();
    this.setState({ tabview: true });
  };
  // getChangeHistory = (entityInstanceId) => {
  //   Axios.get(
  //     `${this.state.env["zqBaseUri"]}/master/changeHistory/getChangeHistory?org=${this.state.orgId}&entity=services&entityInstanceId=${entityInstanceId}`
  //   )
  //     .then((response) => {
  //       let api_data = response.data;
  //       let historyData = [];
  //       api_data.sort((data1, data2) => {
  //         return Number(data2.created_at) - Number(data1.created_at);
  //       });
  //       api_data.map((item) => {
  //         let date = new Date(
  //           new Intl.DateTimeFormat("en-US", {
  //             month: "2-digit",
  //             day: "numeric",
  //             year: "numeric",
  //             hour: "2-digit",
  //             minute: "2-digit",
  //           }).format(item["created_at"])
  //         );
  //         let descriptionData = item.description["0"]
  //           .split(",")
  //           .map((desc, i) => {
  //             return (
  //               <p key={i}>
  //                 <div style={{ display: "flex" }}>
  //                   <span className="span-hist" style={{ width: "5%" }}>
  //                     -
  //                   </span>
  //                   {desc}
  //                 </div>
  //               </p>
  //             );
  //           });
  //         console.log(descriptionData);
  //         historyData.push({
  //           description: descriptionData,
  //           time: moment(date).format("hh:mm"),
  //           created_at: item["created_at"]
  //             ? moment(date).format("DD/MM/YYYY (hh:mm A)")
  //             : "-",
  //           version: item.version,
  //           btn: false,
  //         });
  //       });
  //       this.setState({ historyData: historyData });
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };
  // showHistory = () => {
  //   this.setState({ history: true, showHistory: true });
  // };
  // onCloseForm = () => {
  //   this.setState({ showHistory: false });
  // };



  render() {
    console.log("intime", this.state.timeout - this.state.timeIn)
    return (
      <React.Fragment>
        {/* {this.state.loader ? <Loader /> : null} */}
        <div className="setup-page-wrapper">
          {this.state.tabview ? (
            <React.Fragment>

              {this.state.containerNav == undefined ? null : (
                <React.Fragment>
                  <KenContainerNavbar
                    containerNav={this.state.containerNav}
                    onAddNew={() => {
                      this.resetform();
                      this.onAddServices();
                    }}
                  />
                  <div className="print-time">{this.state.printTime}</div>
                </React.Fragment>

              )}
              <div className="trial-balance-header-title">
                <KeyboardBackspaceSharpIcon className="keyboard-back-icon" onClick={() => { this.props.history.push('/main/dashboard') }} style={{
                  marginRight: '5px',
                  cursor: 'pointer',
                  marginTop: '0px'
                }} />
                <p className="top-header-title" onClick={() => { this.props.history.push('/main/dashboard') }}>| Shift Schedules</p>
              </div>
              <div
                className="table-wrapper"
                style={{ marginTop: "10px" }}
              >
                {this.state.tabData.length == 0 ||
                  this.state.loader ? (
                  <p className="noprog-txt">{this.state.tableResponse}</p>
                ) : (
                  <React.Fragment>
                    <div className="remove-last-child-table shiftTiming">
                      <KenTable
                        data={this.state.tabData}
                        rowClick={(item) => {
                          this.onPreviewServices(item);
                        }}
                      />
                    </div>
                  </React.Fragment>
                )}
                <div className="setup-pagination">
                  {this.state.tabData.length !== 0 && (
                    <KenPaginationUI
                      total={this.state.totalRecord}
                      onPaginationApi={this.onPaginationChange}
                      totalPages={this.state.totalPages}
                      limit={this.state.limit}
                    />
                  )}
                </div>
              </div>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <div className="tab-form-wrapper">
                <div className="goods-btns services-btns">
                  <div className="preview-header-wrap">
                    <div className="trial-balance-header-title">
                      <KeyboardBackspaceSharpIcon className="keyboard-back-icon" onClick={() => { this.handleBack() }} style={{
                        marginRight: '5px',
                        cursor: 'pointer',
                        marginTop: '0px'
                      }} />
                      {this.state.preview ?
                        <p className="top-header-title" onClick={() => { this.handleBack() }}>| Shift Schedules | {this.state.shiftId}</p> :
                        <p className="top-header-title" onClick={() => { this.handleBack() }}>| Shift Schedules | {this.state.addShiftId}</p>}
                    </div>
                    {/* {this.state.preview ? (
                        <React.Fragment>
                          <div
                            className="active-status-wrapper"
                            style={{ marginLeft: "10px" }}
                          >
                            <p className="active-status-content">Active</p>
                          </div>
                        </React.Fragment>
                      ) : null} */}
                  </div>
                  {/* <div className="notes-history-wrapper">
                    {this.state.preview ? (
                      <div
                        className="history-icon-box"
                        title="View History"
                        onClick={this.showHistory}
                      >
                        <img src={HistoryIcon} /> <p>Change History</p>
                      </div>
                    ) : null}
                  </div> */}
                </div>
                <div className="goods-wrapper service-wrapper2 form-heading-tab">

                  <KenForm
                    formData={this.state.ServiceFormData}
                    className="goods-wrap"
                    onInputChanges={this.onInputChanges}
                    onFormBtnEvent={(item) => {
                      this.formBtnHandle(item);
                    }}
                    clear={true}
                    onSubmit={(e) => this.onSubmit(e.target.elements)}
                  />
                </div>
                {/* <div className="notes-history-wrapper">
                    {this.state.preview ? (
                      <div
                        className="history-icon-box"
                        title="View History"
                        onClick={this.showHistory}
                      >
                        <img src={HistoryIcon} /> <p>Change History</p>
                      </div>
                    ) : null}
                  </div> */}
              </div>
            </React.Fragment>
          )}
        </div>
        {/* {this.state.history ? (
          <Drawer show={this.state.showHistory} onHide={this.close}>
            <ZqHistory
              historyData={this.state.historyData}
              onCloseForm={this.onCloseForm}
            />
          </Drawer>
        ) : null} */}
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          open={this.state.snackBar}
          autoHideDuration={1000}
          message={this.state.processMessage}
          className="success-snackbar"

        />
      </React.Fragment>
    );
  }
}
export default withRouter(ShiftSchedule);
